/**
 * Base class for all cryptographic algorithm implementations.
 */
export abstract class CryptoAlgorithm {}